<template>
  <div class="avocash-metric-section">
    <div class="display-flex justify-content-space-between align-items-center mb-3">
      <h3 class="font-headline-sm font-bold text-on-surface m-0">{{ $t('groupDashboard.members') || 'Métriques du Groupe' }}</h3>
      <f7-badge class="avocash-cycle-badge font-label-sm font-semibold">Cycle Actuel</f7-badge>
    </div>

    <!-- Highlights: Total Collecté & Active Members -->
    <div class="grid grid-cols-2 gap-2.5 mb-2">
      <f7-card class="avocash-highlight-card primary-card" :padding="false">
        <f7-card-content class="avocash-highlight-card-content" :padding="false">
          <div class="avocash-card-bg-icon">
            <f7-icon material="group" :size="64" />
          </div>
          <div class="avocash-card-main">
            <span class="font-label-sm font-semibold uppercase tracking-wide opacity-85 mb-1 d-block">{{ $t('groupDashboard.activeMembers') || 'Membres actifs' }}</span>
            <div class="font-headline-lg font-bold">
              {{ fmt(data.activeMembers) }}
              <span class="font-body-md font-medium opacity-75">/ {{ fmt(data.totalMembers) }}</span>
            </div>
            <div class="display-flex align-items-center gap-1 font-label-sm font-semibold mt-2" style="color: #a5f4bf;">
              <f7-icon material="trending_up" :size="14" />
              <span>+{{ pct(data.memberGrowthRate) }} ce mois</span>
            </div>
          </div>
        </f7-card-content>
      </f7-card>

      <f7-card class="avocash-highlight-card secondary-card" :padding="false">
        <f7-card-content class="avocash-highlight-card-content" :padding="false">
          <div class="avocash-card-main">
            <span class="font-label-sm font-semibold uppercase tracking-wide opacity-85 mb-1 d-block">{{ $t('groupDashboard.adminCount') || 'Administrateurs' }}</span>
            <div class="font-headline-lg font-bold text-on-surface">
              {{ fmt(data.adminCount) }}
            </div>
            <div class="display-flex align-items-center gap-1 font-label-sm font-semibold mt-2 text-on-surface-variant">
              <f7-icon material="security" :size="14" />
              <span>Double signature</span>
            </div>
          </div>
        </f7-card-content>
      </f7-card>
    </div>

    <!-- Secondary metric cards -->
    <div class="grid grid-cols-3 gap-2">
      <f7-card class="avocash-subcard" :padding="false">
        <f7-card-content class="avocash-subcard-content" :padding="false">
          <span class="font-headline-md font-bold text-on-surface d-block">{{ fmt(data.newMembersToday) }}</span>
          <span class="font-label-sm text-outline d-block">{{ $t('groupDashboard.newMembersToday') || "Aujourd'hui" }}</span>
        </f7-card-content>
      </f7-card>
      <f7-card class="avocash-subcard" :padding="false">
        <f7-card-content class="avocash-subcard-content" :padding="false">
          <span class="font-headline-md font-bold text-on-surface d-block">{{ fmt(data.newMembersThisWeek) }}</span>
          <span class="font-label-sm text-outline d-block">{{ $t('groupDashboard.newMembersThisWeek') || 'Cette semaine' }}</span>
        </f7-card-content>
      </f7-card>
      <f7-card class="avocash-subcard" :padding="false">
        <f7-card-content class="avocash-subcard-content" :padding="false">
          <span class="font-headline-md font-bold text-on-surface d-block">{{ fmt(data.newMembersThisMonth) }}</span>
          <span class="font-label-sm text-outline d-block">{{ $t('groupDashboard.newMembersThisMonth') || 'Ce mois' }}</span>
        </f7-card-content>
      </f7-card>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({ data: { type: Object, required: true } });
function fmt(n) { return n != null ? Math.round(n).toLocaleString('fr-FR') : '-'; }
function pct(v) { return v != null ? v.toFixed(1) + '%' : '0%'; }
</script>

<style scoped>
.avocash-metric-section {
  margin-bottom: 20px;
}
.avocash-cycle-badge {
  padding: 4px 10px;
  border-radius: 9999px;
}
.avocash-highlight-card {
  border-radius: 16px;
  min-height: 110px;
  box-shadow: 0 2px 8px -2px rgba(26, 107, 66, 0.08);
}
.avocash-highlight-card-content {
  position: relative;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.primary-card {
  background: #1A6B42;
  color: #ffffff;
}
.secondary-card {
  background: var(--f7-card-bg-color, #fff);
  border: 1px solid rgba(111, 122, 113, 0.12);
  color: #161d18;
}
.avocash-card-bg-icon {
  position: absolute;
  right: -8px;
  bottom: -8px;
  opacity: 0.12;
  pointer-events: none;
}
.avocash-card-main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.avocash-subcard {
  border-radius: 12px;
  border: 1px solid rgba(111, 122, 113, 0.1);
  box-shadow: 0 1px 3px rgba(0,0,0,0.03);
}
.avocash-subcard-content {
  padding: 10px 8px;
  text-align: center;
}
</style>
